<template>
    <div class="context common_table_view">
        <div class="header">
            <div class="search search_box">
            </div>
            <div class="btn_box">
                <el-button @click="changeEdit"
                           v-if="!edit_all"
                           type="primary"
                           size="small">
                    编辑
                </el-button>
                <el-button @click="setAll"
                           v-else
                           type="primary"
                           size="small">
                    保存
                </el-button>
            </div>
        </div>

        <div class="table">
            <el-table :data="tableData"
                      stripe
                      width="100%"
                      height="100%">
                <el-table-column type="index" width="65" label="序号"></el-table-column>
                <el-table-column v-for="(item, index) in columnData"
                                 :prop="item.prop"
                                 :label="item.label"
                                 :width="item.width"
                                 :formatter="item.formatter"
                                 :fixed="item.fixed"
                                 show-overflow-tooltip
                                 :key="index">
                    <template slot-scope="scope">
                        <div v-if="item.prop === 'score_start'">
                            <div v-if="edit_all">
                                <span>
                                    <el-input-number v-model="scope.row.score_start"
                                                     controls-position="right"
                                                     @change="changeStart(scope.$index)"
                                                     :disabled="scope.$index === 0"
                                                     :min="0"></el-input-number>
                                </span>
                                <span> ~ </span>
                                <span>
                                    <el-input-number v-model="scope.row.score_end"
                                                     controls-position="right"
                                                     @change="changeEnd(scope.$index)"
                                                     :min="scope.row.score_start + 1"></el-input-number>
                                </span>
                            </div>
                            <div v-else>
                                <span>{{scope.row.score_start}}</span>
                                <span> ~ </span>
                                <span>{{scope.row.score_end}}</span>
                            </div>
                        </div>

                        <div v-if="item.prop === 'title'">
                            <div v-if="edit_all">
                                <el-input class="width_300"
                                          placeholder="请输入积分等级"
                                          v-model="scope.row.title"></el-input>
                            </div>
                            <div v-else>
                                <span>{{scope.row.title}}</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="150" v-if="edit_all">
                    <template slot-scope="scope">
                        <span class="table_btn"
                              @click="addRow(scope.$index)">
                            <i class="el-icon-circle-plus-outline"></i>
                            添加
                        </span>
                        <span class="table_del_btn"
                              v-if="scope.$index != 0"
                              @click="delRow(scope.$index)">
                            <i class="el-icon-delete"></i>
                            删除
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import {clone} from "@/global/utils";

    export default {
        name: "tableView",
        data() {
            return {
                edit_all: false,

                tableData: [],
                columnData: [
                    {label: '积分范围', prop: 'score_start'},
                    {label: '积分等级', prop: 'title'},
                ]
            }
        },
        mounted() {
            this.getTableData()
        },
        methods: {
            changeEdit() {
                this.edit_all = true;
                if (this.tableData.length === 0) {
                    let row = {
                        score_start: 0,
                        score_end: 10,
                        title: '',
                    };
                    this.tableData.push(row)
                }
            },
            setAll() {
                this.edit_all = false;
                let has_not = false;
                this.tableData.forEach(v => {
                    if (!v.title) {
                        has_not = true
                    }
                });
                if (has_not) {
                    this.$message.warning('有积分等级没有输入，请输入');
                    return
                }
                this.httpPost('/points/level', this.tableData).then(res => {
                    this.$message.success('更新成功！');
                    this.getTableData()
                })
            },

            addRow(index) {
                let last_row = this.tableData[index];
                let item = {
                    score_start: last_row.score_end + 1,
                    score_end: last_row.score_end + 11,
                    title: '',
                };
                this.tableData.splice(index + 1, 0, item);
                console.log(item,this.tableData, '80');
                this.calcAllTable()
            },
            delRow(index) {
                this.tableData.splice(index, 1);
                this.calcAllTable()
            },
            changeStart(index) {
                let row = this.tableData[index];
                let last = index > 0 ? this.tableData[index - 1] : null;
                if (last) {
                    last.score_end = row.score_start - 1 > 0 ? row.score_start - 1 : 1;
                }
                if (row.score_end <= row.score_start) {
                    row.score_end = row.score_start + 1
                }
                this.calcAllTable()
            },
            changeEnd(index) {
                let row = this.tableData[index];
                let next = index > 0 ? this.tableData[index + 1] : null;
                if (next) {
                    next.score_start = row.score_end + 1
                }
                this.calcAllTable()
            },

            calcAllTable() {
                for (let i = 0; i < this.tableData.length; i++) {
                    let row = this.tableData[i];
                    let next = i+1 < this.tableData.length ? this.tableData[i+1] : null;

                    if (row.score_start >= row.score_end) {
                        row.score_end = row.score_start + 1
                    }
                    if (next) {
                        next.score_start = row.score_end + 1
                    }
                }
            },

            getTableData() {
                this.httpGet('/points/level').then(res => {
                    this.tableData = res.data
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .context {
        width: 100%;
        height: 100%;
    }
</style>